<template>
  <b-tab title="Checklist" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="ChecklistPrint">
        <b-container fluid>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE SUPERIOR DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="3">
              <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
            </b-col>

            <b-col cols="6" class="pt-1">
              <h4 class="exo-2 center-text pt-4">CHECKLIST</h4>
              <h4 class="exo-2 center-text">LISTA DE VERIFICAÇÃO</h4>
            </b-col>

            <b-col cols="3" class="pl-5">
              <b-row><p class="m-0 p-0">ID. Relatório</p></b-row>
              <b-row><b-form-input size="sm" v-model="checklist.numero" /></b-row>
              <b-row><p class="m-0 p-0">Data</p></b-row>
              <b-row>
                <b-form-datepicker
                  size="sm"
                  v-model="checklist.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
              </b-row>
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: IDENTIFICAÇÃO DO EQUIPAMENTO :::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>IDENTIFICAÇÃO DO EQUIPAMENTO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Equipamento / Equipment</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Identificação / Identification</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-4">
              <p class="m-0 p-0">Código / Serial no.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.nome" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.sgcq" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.codigo" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Dimensões / Dimensions</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Fabricante / Manufacturer</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Peso / Weight</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Carga / Work load</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.dimensoes" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.fabricante" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.peso" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="equipamento.carga" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0">Descrição / Description</p>
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <p class="m-0 p-0">Local / Local</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Período / Period</p>
            </b-col>
            <b-col cols="2" class="p-0 pl-4">
              <p class="m-0 p-0">Resultado / Result</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="checklist.detalhe" />
            </b-col>
            <b-col cols="4" class="p-0 pl-2">
              <b-form-input size="sm" v-model="checklist.local" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="checklist.periodo" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="checklist.resultado" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::: ITENS DO CHECKLIST ::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>ITENS VERIFICADOS</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <b-table id="table-item" hover small :items="checklist.itens" :fields="fields.item_checklist">
                <template #cell(item)="data">
                  <div>
                    <b-form-textarea v-model="data.item.item" :rows="checks" />
                  </div>
                </template>
                <template #cell(conjunto)="data">
                  <div>
                    <b-form-textarea v-model="data.item.conjunto" :rows="checks" />
                  </div>
                </template>
                <template #cell(descricao)="data">
                  <div>
                    <b-form-textarea v-model="data.item.descricao" :rows="checks" />
                  </div>
                </template>
                <template #cell(laudo)="data">
                  <div v-if="data.item.laudo == true">
                    <p class="m-0 pl-3 mt-2 text-left">
                      <b-icon icon="check-square" scale="1.5" variant="success" class="mr-1" />
                      OK
                    </p>
                    <p class="m-0 pl-3 mt-2 text-left">
                      <b-icon icon="square" scale="1.5" variant="danger" class="mr-1" />
                      NOK
                    </p>
                  </div>

                  <div v-if="data.item.laudo == false">
                    <p class="m-0 pl-3 mt-2 text-left">
                      <b-icon icon="square" scale="1.5" variant="success" class="mr-1" />
                      OK
                    </p>
                    <p class="m-0 pl-3 mt-2 text-left">
                      <b-icon icon="check-square" scale="1.5" variant="danger" class="mr-1 ml-1" />
                      NOK
                    </p>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::: DETALHES FINAIS :::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>DETALHES SOBRE EQUIPAMENTO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="m-0 p-0">
              <div class="p-3 m-1 borda-cliente max-size">
                <b-img
                  :src="imagem == null ? require('/static/images/report.png') : imagem"
                  class="max-size-img"
                  center
                  fluid
                  width="300"
                />
              </div>
            </b-col>
            <b-col cols="8" class="m-0 p-0">
              <b-row class="text-left m-1">
                <b-form-textarea v-model="checklist.observacao" :rows="linhas" />
              </b-row>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE INFERIOR DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>RESPONSÁVEL</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0"> </b-col>
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>CLIENTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2 mb-2">
            <b-col cols="4">
              <inspetor-stamp
                :profissional="checklist.inspetor"
                :preview="stampInspetor"
                :posicao="'6rem'"
                key="insp-stamp-check"
              />
            </b-col>
            <b-col cols="4" class="m-0 p-0"> </b-col>
            <b-col cols="4">
              <div class="borda-cliente">
                <b-img
                  :src="logoCliente == null ? require('/static/images/sgcq_default.png') : logoCliente"
                  class="rounded-0"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- ::::::::::::::::::::::::::::::: MODAL DE EDIÇÃO ::::::::::::::::::::::::::::::: -->
    <checklist-modal ref="tChecklist" />
    <checklist-itens-modal ref="tChecklistItens" />
    <!-- :::::::::::::::::::::::::::: COMANDOS DO RELATÓRIO :::::::::::::::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input id="sgcq-call" type="number" size="sm" class="m-1 p-1" placeholder="Sgcq" v-model="sgcq" />
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="primary" @click="loadEquipamento()">
              <b-icon icon="box-arrow-in-up-right" variant="light" scale="1.1" class="mr-2" />Buscar
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadDetalhes()">
              <b-icon icon="file-earmark-richtext" variant="light" scale="1.1" class="mr-2" />Detalhes
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="callItens()">
              <b-icon icon="file-break" variant="light" scale="1.1" class="mr-2" />Itens
            </b-button>
            <b-button size="sm" class="ml-2 pl-2 pr-3" variant="warning" v-print="printLaudo">
              <b-icon icon="printer" variant="light" scale="1.1" class="mr-2" />Imprimir
            </b-button>

            <b-form-input id="size-lines" type="number" size="sm" class="m-1 p-1" v-model="checks" />
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import Checklist from "@/models_reports/Checklist";
import Cliente from "@/models/Cliente";
import Equipamento from "@/models/Equipamento";
import Files from "@/http/files";
import StampCertificado from "@/components/supports/StampCertificado";
import ChecklistModal from "@/components/modals/relatorio/ChecklistModal";
import ChecklistItensModal from "@/components/modals/relatorio/ChecklistItensModal";
import ReportFields from "@/tools/ReportFields";

export default {
  name: "ChecklistReport",

  components: {
    "inspetor-stamp": StampCertificado,
    "checklist-modal": ChecklistModal,
    "checklist-itens-modal": ChecklistItensModal,
  },

  data() {
    return {
      sgcq: 0,
      ativo: false,
      checklist: new Checklist(),
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", ""),
      identificacao: "",
      stampInspetor: null,
      logoCliente: null,
      imagem: null,
      fields: new ReportFields(),
      files: new Files(this.$http),
      linhas: 10,
      checks: 5,
      printLaudo: {
        id: "ChecklistPrint",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
    };
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore.LISTAR_SERVICOS(this.equipamento.sgcq).then(() => {
          let servicoData = new Date(this.getLastServico[0].data);
          this.checklist.data = new Date(this.getLastServico[0].data);
          let ano = servicoData.getFullYear();
          this.checklist.numero = "RN" + this.getLastServico[0].id + "-" + this.sgcq + "-" + ano + "-CK";
          this.identificacao = this.equipamento.sgcq;
          if (this.equipamento.codigo != "" && this.equipamento.codigo != "- - -") {
            this.identificacao = this.equipamento.sgcq + " - " + this.equipamento.codigo;
          }

          //carrega a imagem do equipamento
          this.files.downloadEquipamento(this.equipamento.sgcq).then((response) => {
            const reader = new FileReader();
            const blob = new Blob([response]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.imagem = e.target.result;
            };
          });

          //carrega a logomarca do cliente
          this.files.downloadLogo(this.cliente.id).then((response) => {
            const reader = new FileReader();
            const blob = new Blob([response]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.logoCliente = e.target.result;
            };
          });
        });
      }
    },

    loadDetalhes() {
      this.$refs.tChecklist.call(this.checklist);
    },

    callItens() {
      this.$refs.tChecklistItens.call(this.checklist);
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getBySgcq,
      getLastServico,
    };
  },
};
</script>

<style lang="scss" scoped>
.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}

.exo-2 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.8rem;
  text-align: center;
}

.center-text {
  text-align: justify; /* For Edge */
  text-align-last: center;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #009999;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.borda-cliente {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding-top: 1rem;
  padding-left: 3rem;
  min-height: 8.8rem;
}

#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

#sgcq-call {
  width: 6rem;
}

.menu-acoes {
  background-color: #112a4a;
}
.legend {
  border: 1px solid lightgray;
  font-size: 0.8rem;
}

#sgcq-call {
  width: 6rem;
}

#size-lines {
  width: 4rem;
}

.conf-bar {
  margin-left: 15rem;
}
</style>
